<template>
  <div class="app-container">
    <list ref="list">
      <template slot="toolbar-right" v-if="$permission.canWrite()">
        <!-- <el-button size="mini" type="success" plain @click="importTeacher" v-if="!isMB">导入</el-button>
        <el-button size="mini" type="primary" plain @click="exportTeacher" v-if="!isMB">导出</el-button> -->
        <el-button size="mini" type="primary" @click="create">添加</el-button>
        <el-button size="mini" type="danger" @click="delRows">删除</el-button>
      </template>
      <template slot="column" v-if="$permission.canWrite()">
        <el-table-column label="操作" fixed="right" align="center" :width="isMB?'60px':'90px'">
          <template slot-scope="{row}">
            <!-- <el-button type="text" @click="setMsg(row)">管理班级</el-button> -->
            <el-button type="text" @click="editById(row.TeacherId)" size="medium" icon="el-icon-edit-outline" title="编辑"></el-button>
          </template>
        </el-table-column>
      </template>
      <template slot="column" v-else>
        <el-table-column label="操作" fixed="right" align="center" width="120px">
          <template slot-scope="{row}">
            <el-button type="text" @click="setMsg(row)">查看消息设置</el-button>
          </template>
        </el-table-column>
      </template>
    </list>
    <edit-dialog ref="editDialog" @close-saved="reload"></edit-dialog>
    <import-dialog ref="importDialog" @upload-success="reload" />
    <msg-dialog ref="msgDialog" @close-saved="reload" />
  </div>
</template>
<script>
import curdMixins from "@/mixins/curd";
import list from "@/components/sys/teacher/list";
import editDialog from "@/components/sys/teacher/editDialog";
import importDialog from "@/components/sys/teacher/importDialog";
import msgDialog from "@/components/sys/teacher/msgDialog";

export default {
  name: "teacher",
  mixins: [curdMixins],
  components: {
    list,
    editDialog,
    importDialog,
    msgDialog,
  },
  data() {
    return {
      isMB: this.$store.state.isMB,
    };
  },
  methods: {
    importTeacher() {
      this.$refs.importDialog.open();
    },
    exportTeacher() {
      console.log("exportTeacher");
      this.$refs.list.export();
    },
    setMsg(row) {
      this.$refs.msgDialog.open(row);
    },
    delRows() {
      let rows = this.$refs.list.getCheckedRows();
      if (rows.length == 0) {
        this.$message.warning("请选择要删除的数据");
        return;
      }
      this.$confirm("确认删除所选的数据吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let ids = rows.map((item) => {
            return item.TeacherId;
          });
          this.$refs.list.delRange(ids);
        })
        .catch(() => {});
    },
  },
};
</script>